<template>
        <v-app id="inspire" class="bg-dark">
          <div class="container">
            <v-timeline>
              <v-timeline-item
                v-for="annee in annees"
                :key="annee.titre._text"
                big
                color="orange"
              >
                <template v-slot:opposite>
                  <span
                    class="headline font-weight-bold"
                    style="color:orange"
                    v-text="annee.titre._text"
                  ></span>
                </template>
                <v-card class="elevation-24">
                  <v-card-text>
                    <p class="font-weight-bold"  v-for="expo in selectExpos(annee.titre._text)" :key="expo.id" v-text="expo.contenu._text"></p>
                  
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </div>
        </v-app>
</template>

<script>
import Vuetify from 'vuetify';
import axios from 'axios';
import convert from 'xml-js';

export default {
  name: 'Expos',
  vuetify: new Vuetify(),
  data:() =>{
    return{
      expos:[],
      annees:[],
      searchKey:'',
    }
  },
  methods:{
    selectExpos:function(paramAnnne){
      var exposAnnnes=[];
      for (var i = 0; i < this.expos.length; i++) {
        if(paramAnnne==this.expos[i].titre._text){
          exposAnnnes.push(this.expos[i]);
        }
      }
      return exposAnnnes;
    },   
  },
  async beforeMount(){
    const respannee = await axios.get('/inc/data-expo-annees.xml');
    const respexpo = await axios.get('/inc/data-expo.xml');  
    var xmloptions = {compact: true, ignoreComment: true,alwaysChildren:true};
    var localexpos = JSON.parse(convert.xml2json(respexpo.data, xmloptions)).expos.expo;
    for (var iexpo = 1; iexpo < localexpos.length; iexpo++) {       
          this.expos.push(localexpos[iexpo]);
      }
    var localannees = JSON.parse(convert.xml2json(respannee.data, xmloptions)).annees.annee;
    for (var iannee = 1; iannee < localannees.length; iannee++) {
          this.annees.push(localannees[iannee]);
      }
  },
}
</script>

<style>


</style>